// File: frontend/src/services/api.js

import axios from 'axios';

// Create Axios Instance
const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

// Request Interceptor (Adds Token to every request)
API.interceptors.request.use((req) => {
    if (localStorage.getItem('token')) {
        req.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    }
    return req;
});

// --- AUTHENTICATION ---
export const login = (formData) => API.post('/api/auth/login', formData);
export const registerUser = (formData) => API.post('/api/auth/register', formData);
export const updateDetails = (data) => API.put('/api/auth/updatedetails', data);

// --- TEAM MANAGEMENT ---
export const fetchEditors = () => API.get('/api/auth/editors'); 
export const deleteUser = (id) => API.delete(`/api/auth/users/${id}`); 
export const updateUser = (id, data) => API.put(`/api/auth/users/${id}`, data); 

// --- ARTICLES (Read Operations) ---
export const fetchArticles = () => API.get('/api/articles'); 
export const fetchHomeFeed = (lang) => API.get(`/api/articles/feed?lang=${lang || 'en'}`); // Feed accepts language

export const fetchArticleBySlug = (slug) => API.get(`/api/articles/slug/${slug}`);
export const fetchArticleById = (id) => API.get(`/api/articles/id/${id}`);
export const fetchArticlesBySearch = (query) => API.get(`/api/articles/search?q=${query}`);

// 🔥 FIXED: Category API now accepts 'lang' parameter
export const fetchArticlesByCategory = (category, subcategory, district, lang) => {
    let url = `/api/articles/category/${category}`;
    if (subcategory) { 
        url += `/${subcategory}`; 
        if (district) url += `/${district}`; 
    }
    // Append language query param to tell backend which language we want
    url += `?lang=${lang || 'en'}`;
    return API.get(url);
};

// --- RELATED & TOP NEWS ---
export const fetchRelatedArticles = (category, slug, lang, limit = 4) => API.get(`/api/articles/related?category=${category}&slug=${slug}&lang=${lang}&limit=${limit}`);
export const fetchTopNews = (language, currentSlug = '') => API.get(`/api/articles/top-news?lang=${language}&exclude=${currentSlug}`);

// --- WRITE OPERATIONS ---
export const createArticle = (formData) => API.post('/api/articles', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateArticle = (id, formData) => API.put(`/api/articles/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteArticle = (id) => API.delete(`/api/articles/${id}`);

// --- ADMIN ---
export const fetchAdminArticles = () => API.get('/api/articles/admin/all'); 
export const updateArticleStatus = (id, status) => API.put(`/api/articles/${id}/status`, { status });

// --- DIRECT IMAGE UPLOAD (For Rich Text Editor) ---
export const uploadImage = (formData) => API.post('/api/articles/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

// --- SUBSCRIBERS ---
export const fetchSubscribers = () => API.get('/api/auth/subscribers'); 
export const addSubscriber = (email) => API.post('/api/auth/subscribe', { email });

// --- CONTACT & ANALYTICS ---
export const sendContactMessage = (formData) => API.post('/api/contact/send', formData);
export const trackVisit = (data) => API.post('/api/analytics/track', data);
export const fetchAnalytics = () => API.get('/api/analytics/stats');

export const fetchWebStories = async () => {
    // Backend URL sahi hona chahiye
    const response = await axios.get('https://indiajagran-backend.onrender.com/web-stories/recent/all');
    return response.data;
};